import { NgModule } from '@angular/core'
import { SharedModule } from 'lib-trend-core'
import { AgentConfigsFormModule } from './agent-trendgpt/agent-configs-form/agent-configs-form.module'
import { AgentIntentionsFormComponent } from './agent-trendgpt/agent-intentions-form/agent-intentions-form.component'
import { IntentionModalComponent } from './agent-trendgpt/agent-intentions-form/intention-modal/intention-modal.component'
import { AgentTrainingFormComponent } from './agent-trendgpt/agent-training-form/agent-training-form.component'
import { AgentTrendgptFormComponent } from './agent-trendgpt/agent-trendgpt-form/agent-trendgpt-form.component'
import { AgentTrendgptModalComponent } from './agent-trendgpt/agent-trendgpt-modal/agent-trendgpt-modal.component'
import { AgentTrendgptComponent } from './agent-trendgpt/agent-trendgpt.component'
import { AgentsComponent } from './agents.component'
import { AgentsRoutingModule } from './agents.routing.module'
import { AgentOpenAIComponent } from './agent-openai/agent-openai.component'
import { AgentOpenAIModalComponent } from './agent-openai/agent-openai-modal/agent-openai-modal.component'
import { AgentOpenAIIntegrationFormComponent } from './agent-openai/agent-openai-integration-form/agent-openai-integration-form.component'
import { AgentOpenAIAssistantsComponent } from './agent-openai/agent-openai-assistants/agent-openai-assistants.component'
import { AgentOpenAIAssistantFormComponent } from './agent-openai/agent-openai-assistant-form/agent-openai-assistant-form.component'

@NgModule({
  imports: [
    SharedModule, 
    AgentsRoutingModule,
    AgentConfigsFormModule
  ],
  declarations: [
    AgentsComponent,
    AgentTrendgptComponent,
    AgentTrendgptFormComponent,
    AgentTrendgptModalComponent,
    AgentIntentionsFormComponent,
    IntentionModalComponent,
    AgentTrainingFormComponent,
    AgentOpenAIComponent,
    AgentOpenAIModalComponent,
    AgentOpenAIIntegrationFormComponent,
    AgentOpenAIAssistantsComponent,
    AgentOpenAIAssistantFormComponent,
  ],
  exports: [AgentsComponent],
  providers: [],
})
export class AgentsModule { }
